var render = function render(){
  var _vm$data, _vm$data$courier_assi, _vm$data2, _vm$data3, _vm$data3$courier_ass, _vm$data4, _vm$data4$courier_ass, _vm$data5, _vm$data5$courier_ass;

  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "order-card"
  }, [_c('div', {
    staticClass: "px-6 py-4 flex justify-between items-center shadow-border-b mdmax:px-4 mdmax:py-4"
  }, [_c('div', {
    staticClass: "flex gap-3 mdmax:items-start mdmax:gap-1 mdmax:flex-col justify-between items-center"
  }, [_c('span', [_c('span', {
    staticClass: "inline-flex px-2 py-1 text-sm rounded-md mdmax:flex-shrink-0 capitalize",
    class: _vm.statusClass || 'text-neutral-500 bg-neutral-300'
  }, [_vm._v(_vm._s(_vm.data.internal))])]), _c('div', [_c('span', {
    staticClass: "text-neutral-500 mdmax:text-sm block text-xs mb-1"
  }, [_vm._v(_vm._s(_vm._f("formatDate")(_vm.data.order_delivery_schedule)) + " / " + _vm._s(_vm.data.id))]), _c('span', {
    staticClass: "text-neutral-500 mdmax:text-sm block text-xs"
  }, [_vm._v("Kode Booking: " + _vm._s(_vm.data.order_booking_code))])])]), _c('div', {
    staticClass: "flex gap-6"
  }, [_vm.isMobile ? _c('span', {
    staticClass: "inline-block cursor-pointer",
    on: {
      "click": function ($event) {
        return _vm.expand();
      }
    }
  }, [_c('Chevron', {
    attrs: {
      "direction": "down"
    }
  })], 1) : _vm._e(), (_vm$data = _vm.data) !== null && _vm$data !== void 0 && (_vm$data$courier_assi = _vm$data.courier_assigned) !== null && _vm$data$courier_assi !== void 0 && _vm$data$courier_assi.id && !_vm.isMobile ? _c('div', {
    staticClass: "courier flex items-center gap-6"
  }, [_c('div', {
    staticClass: "partner w-10 h-10 rounded-full flex justify-center items-center"
  }, [_c('img', {
    staticClass: "rounded-full",
    attrs: {
      "src": (_vm$data2 = _vm.data) === null || _vm$data2 === void 0 ? void 0 : _vm$data2.courier_assigned.partner_icon
    }
  })]), _c('div', {
    staticClass: "flex gap-3 items-center"
  }, [_c('div', {
    staticClass: "w-7 h-7 rounded-full flex justify-center items-center"
  }, [_c('img', {
    staticClass: "rounded-full",
    attrs: {
      "src": (_vm$data3 = _vm.data) === null || _vm$data3 === void 0 ? void 0 : (_vm$data3$courier_ass = _vm$data3.courier_assigned) === null || _vm$data3$courier_ass === void 0 ? void 0 : _vm$data3$courier_ass.photo
    }
  })]), _c('div', {}, [_c('p', {
    staticClass: "text-sm"
  }, [_vm._v(_vm._s((_vm$data4 = _vm.data) === null || _vm$data4 === void 0 ? void 0 : (_vm$data4$courier_ass = _vm$data4.courier_assigned) === null || _vm$data4$courier_ass === void 0 ? void 0 : _vm$data4$courier_ass.name))]), _c('p', {
    staticClass: "text-neutral-500 text-xs"
  }, [_vm._v(_vm._s((_vm$data5 = _vm.data) === null || _vm$data5 === void 0 ? void 0 : (_vm$data5$courier_ass = _vm$data5.courier_assigned) === null || _vm$data5$courier_ass === void 0 ? void 0 : _vm$data5$courier_ass.phone_number))])])])]) : _c('Button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: !_vm.isMobile,
      expression: "!isMobile"
    }],
    attrs: {
      "disabled": "",
      "buttonText": "Assign Otomatis"
    }
  }), !_vm.isMobile ? _c('Button', {
    attrs: {
      "buttonText": "Lebih Rinci",
      "type": "secondary"
    },
    on: {
      "action": function ($event) {
        return _vm.goToDetail(_vm.data.id);
      }
    }
  }) : _vm._e()], 1)]), _c('div', {
    staticClass: "flex justify-between items-start shadow-border-b text-neutral-500 mdmax:flex-col mdmax:shadow-none",
    class: {
      hidden: !_vm.visibleContent && _vm.isMobile
    }
  }, [_c('div', {
    staticClass: "w-2/5 border-r p-6 mdmax:w-full mdmax:p-4 mdmax:border-none mdmax:shadow-border-b"
  }, [_vm.isMobile ? _c('div', {
    staticClass: "py-2 mb-2"
  }, [_c('Button', {
    attrs: {
      "buttonText": "Lebih Rinci",
      "type": "secondary",
      "size": "full"
    },
    on: {
      "action": function ($event) {
        return _vm.goToDetail(_vm.data.id);
      }
    }
  })], 1) : _vm._e(), _c('div', {
    staticClass: "flex justify-between items-start gap-6 mdmax:gap-2"
  }, [_c('div', {
    staticClass: "w-2/5 mdmax:w-1/2"
  }, [_c('p', {
    staticClass: "text-sm font-medium mb-1 text-neutral-700"
  }, [_vm._v("Nama Pengirim")]), _c('p', {
    staticClass: "font-medium mb-1"
  }, [_vm._v(_vm._s(_vm.data.sender.name))]), _c('p', [_vm._v(_vm._s(_vm.data.sender.phone_number))])]), _c('div', {
    staticClass: "w-3/5 mdmax:w-1/2"
  }, [_c('p', {
    staticClass: "text-sm font-medium mb-1 text-neutral-700"
  }, [_vm._v("Alamat Pengirim")]), _c('p', {
    staticClass: "ellipsis overflow-hidden mdmax:h-auto mdmax:overflow-auto"
  }, [_vm._v(_vm._s(_vm.data.sender.address))])])]), _c('div', {
    staticClass: "mt-4 p-2 bg-neutral-200 rounded-md"
  }, [_c('p', {
    staticClass: "text-sm font-medium mb-1 text-neutral-700"
  }, [_vm._v("Detail Pickup")]), _c('p', [_vm._v(_vm._s(_vm.data.sender.address_detail_instruction || '-'))])])]), _c('div', {
    staticClass: "w-2/5 border-r p-6 mdmax:border-none mdmax:p-4 mdmax:w-full mdmax:shadow-border-b"
  }, [_c('div', {
    staticClass: "flex justify-between items-start gap-6 mdmax:gap-2"
  }, [_c('div', {
    staticClass: "w-2/5 mdmax:w-1/2"
  }, [_c('p', {
    staticClass: "text-sm font-medium mb-1 text-neutral-700 whitespace-nowrap"
  }, [_vm._v("Nama Penerima")]), _c('p', {
    staticClass: "font-medium mb-1"
  }, [_vm._v(_vm._s(_vm.data.receiver.name))]), _c('p', [_vm._v(_vm._s(_vm.data.receiver.phone_number))])]), _c('div', {
    staticClass: "w-3/5 mdmax:w-1/2"
  }, [_c('p', {
    staticClass: "text-sm font-medium mb-1 text-neutral-700"
  }, [_vm._v("Alamat Penerima")]), _c('p', {
    staticClass: "ellipsis overflow-hidden mdmax:h-auto mdmax:overflow-auto"
  }, [_vm._v(_vm._s(_vm.data.receiver.address))])])]), _c('div', {
    staticClass: "mt-4 p-2 bg-neutral-200 rounded-md"
  }, [_c('p', {
    staticClass: "text-sm font-medium mb-1 text-neutral-700"
  }, [_vm._v("Detail Pengiriman")]), _c('p', [_vm._v(_vm._s(_vm.data.receiver.address_detail_instruction || '-'))])])]), _c('div', {
    staticClass: "w-1/5 p-6 mdmax:w-full mdmax:shadow-border-b"
  }, [_c('div', {
    staticClass: "mb-6"
  }, [_c('p', {
    staticClass: "text-sm font-medium mb-1 text-neutral-700"
  }, [_vm._v("Berat Barang")]), _c('p', [_vm._v(_vm._s(_vm.data.package_weight_kilos) + " kg")])]), _c('div', {}, [_c('p', {
    staticClass: "text-sm font-medium mb-1 text-neutral-700"
  }, [_vm._v("Jenis Paket")]), _c('p', [_vm._v(_vm._s(_vm.data.package_goods_category_display))])])])])]);

}
var staticRenderFns = []

export { render, staticRenderFns }